// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__34LVl","icons":"style_icons__qUU4U","icon":"style_icon__2TBZv","logo":"style_logo__3zSbi"};